<span *ngIf="editIcon" class="editIconCell"><span><img class="editIcon"
                                                       src="../../assets/images/icon_edit_default.svg"/></span>{{params.value}}</span>

<!-- Currency and Percentage span starts -->
<span *ngIf="(isCurrency || isPercent) && !isCashSecuritySymbol && !isNotApplicable && !isDoubleDash && !isBlank && !isNegative"
      style="float:right;" [ngStyle]="{'font-weight': (isBold) ? 'bold' : 'inherit'}">
    <span *ngIf="params.value < 0" style="color:#D30014">
        <span *ngIf="displaySymbol==='$' && decimalPosition === '0' ">
            ({{displaySymbol}}{{(params.value | number:"1.0-0").replace("-", "")}})</span>
        <span *ngIf="displaySymbol==='$' && decimalPosition === '1' ">
            ({{displaySymbol}}{{(params.value | number:"1.1-1").replace("-", "")}})</span>
        <span *ngIf="displaySymbol==='$' && decimalPosition === '2' ">
            ({{displaySymbol}}{{(params.value | number:"1.2-2").replace("-", "")}})</span>
        <span *ngIf="displaySymbol==='$' && decimalPosition === '3' ">
            ({{displaySymbol}}{{(params.value | number:"1.3-3").replace("-", "")}})</span>
        <span *ngIf="displaySymbol==='%' && decimalPosition === '0'">
            ({{(params.value | number:"1.0-0").replace("-", "")}}){{displaySymbol}}</span>
        <span *ngIf="displaySymbol==='%' && decimalPosition === '1'">
            ({{(params.value | number:"1.1-1").replace("-", "")}}){{displaySymbol}}</span>
        <span *ngIf="displaySymbol==='%' && decimalPosition === '2'">
            ({{(params.value | number:"1.2-2").replace("-", "")}}){{displaySymbol}}</span>
        <span *ngIf="displaySymbol==='%' && decimalPosition === '3'">
            ({{(params.value | number:"1.3-3").replace("-", "")}}){{displaySymbol}}</span>
        <span *ngIf="displaySymbol===' ' && decimalPosition === '0'">
            ({{(params.value | number:"1.0-0").replace("-", "")}}){{displaySymbol}}</span>
        <span *ngIf="displaySymbol===' ' && decimalPosition === '1'">
            ({{(params.value | number:"1.1-1").replace("-", "")}}){{displaySymbol}}</span>
        <span *ngIf="displaySymbol===' ' && decimalPosition === '2'">
            ({{(params.value | number:"1.2-2").replace("-", "")}}){{displaySymbol}}</span>
        <span *ngIf="displaySymbol===' ' && decimalPosition === '3'">
            ({{(params.value | number:"1.3-3").replace("-", "")}}){{displaySymbol}}</span>
        <span *ngIf="displaySymbol===' ' && decimalPosition === '4'">
            ({{(params.value | number:"1.4-4").replace("-", "")}}){{displaySymbol}}</span>
    </span>
    <span *ngIf="params.value > 0">
        <span
          *ngIf="displaySymbol==='$' && decimalPosition === '0'">{{displaySymbol}}{{params.value | number:"1.0-0" }}</span>
        <span
          *ngIf="displaySymbol==='$' && decimalPosition === '1'">{{displaySymbol}}{{params.value | number:"1.1-1" }}</span>
        <span
          *ngIf="displaySymbol==='$' && decimalPosition === '2'">{{displaySymbol}}{{params.value | number:"1.2-2" }}</span>
        <span
          *ngIf="displaySymbol==='$' && decimalPosition === '3'">{{displaySymbol}}{{params.value | number:"1.3-3" }}</span>
        <span
          *ngIf="displaySymbol==='%' && decimalPosition === '0'">{{params.value | number:"1.0-0" }}{{displaySymbol}}</span>
        <span
          *ngIf="displaySymbol==='%' && decimalPosition === '1'">{{params.value | number:"1.1-1" }}{{displaySymbol}}</span>
        <span
          *ngIf="displaySymbol==='%' && decimalPosition === '2'">{{params.value | number:"1.2-2" }}{{displaySymbol}}</span>
        <span
          *ngIf="displaySymbol==='%' && decimalPosition === '3'">{{params.value | number:"1.3-3" }}{{displaySymbol}}</span>
        <span *ngIf="displaySymbol===' ' && decimalPosition === '0'">{{params.value | number:"1.0-0" }}</span>
        <span *ngIf="displaySymbol===' ' && decimalPosition === '1'">{{params.value | number:"1.1-1" }}</span>
        <span *ngIf="displaySymbol===' ' && decimalPosition === '2'">{{params.value | number:"1.2-2" }}</span>
        <span *ngIf="displaySymbol===' ' && decimalPosition === '3'">{{params.value | number:"1.3-3" }}</span>
        <span *ngIf="displaySymbol===' ' && decimalPosition === '4'">{{params.value | number:"1.4-4" }}</span>
    </span>
    <span *ngIf="!params.value && !nullCheck">
        <span *ngIf="displaySymbol==='$'">{{displaySymbol}}0</span>
        <span *ngIf="displaySymbol==='%'">0{{displaySymbol}}</span>
        <span *ngIf="displaySymbol===' '">0{{displaySymbol}}</span>        
    </span>{{appendToEnd}}
</span>
<span *ngIf="(isCurrency || isPercent) && (isNotApplicable || isDoubleDash || isBlank || isNegative)" style="float:right;"
      [ngStyle]="{'font-weight': (isBold) ? 'bold' : 'inherit'}">
    <span *ngIf="isNegative && !(isNotApplicable || isDoubleDash || isBlank)"
          [ngStyle]="{'color': (displayValue < 0) ? '#D30014' : 'inherit'}">
         <span *ngIf="decimalPosition === '0'">
            ({{displaySymbol.trim()}}{{(displayValue | number:"1.0-0").replace("-", "")}})</span>
        <span *ngIf="decimalPosition === '1'">
            ({{displaySymbol.trim()}}{{(displayValue | number:"1.1-1").replace("-", "")}})</span>
        <span *ngIf="decimalPosition === '2'">
            ({{displaySymbol.trim()}}{{(displayValue | number:"1.2-2").replace("-", "")}})</span>
        <span *ngIf="decimalPosition === '3'">
            ({{displaySymbol.trim()}}{{(displayValue | number:"1.3-3").replace("-", "")}})</span>        
        <span *ngIf="decimalPosition === '4'">
            ({{displaySymbol.trim()}}{{(displayValue | number:"1.4-4").replace("-", "")}})</span>        
    </span>

    <span *ngIf="!isNegative || (isNegative && (isNotApplicable || isDoubleDash || isBlank))">
        {{displayValue}}
    </span>{{appendToEnd}}
</span>

<!-- Currency and Percentage span ends -->
<span *ngIf="isCashSecuritySymbol">n/a</span>

<span *ngIf="!linkEnable && !isCurrency && !isPercent && !enablePointer && !params.irbCellActionMenu &&
     !dropdown && !editIcon && !checkbox && !statusFormatter && !errorMsg && !params.template && !statusFormatterWithSomeIcon" tooltip
      [tooltipTitle]="toolTipTitle"
      [tooltipPosition]="'right'" [tooltipRequiresTruncation]='true'
      [tooltipHorizontalOffset]='0'>{{appendToStart}} {{params.value}} </span>

<span *ngIf="linkEnable && !isCurrency && !isPercent && !editIcon && !columnToolTipInfo && !params.template" [ngStyle]="{'display': (calltoactionTemplateFunc) ? 'flex' : 'inline'}">
  <a (click)="click()" tooltip
    [tooltipTitle]="toolTipTitle"
    [tooltipPosition]="'right'" [tooltipRequiresTruncation]='true' [tooltipHorizontalOffset]='0'>
    {{params.value}}</a>
  <span style="margin-left: auto; line-height: 30px;">
    <i class="pi pi-eye-slash" style="margin-right: 10px;" *ngIf="showHideIcon"></i>
    <i class="pi pi-ellipsis-v clickable" *ngIf="calltoactionTemplateFunc" calltoaction calltoactionPosition="right" [calltoactionTemplate]="calltoactionTemplate" (click)="getCalltoactionTemplate()"></i>
  </span>
</span>

<span *ngIf="linkEnable && !isCurrency && !isPercent && !editIcon &&  !params.template">
    <div class="cell-dropdown" *ngIf="columnToolTipInfo">
        <div class="input-field">
<a (click)="click()" tooltip [tooltipTitle]="toolTipTitle"
   [tooltipPosition]="'right'" [tooltipRequiresTruncation]='true' [tooltipHorizontalOffset]='0'>
   {{params.value}}</a>

    <span class="infoIcon" calltoaction [calltoactionTemplate]="irbColInfoTemplateRef">
        <ng-template #irbColInfoTemplateRef><div [innerHTML]="columnToolTipInfo"></div></ng-template>
    </span>
</div>
</div> 
</span>
<span class="pointer-element" *ngIf="enablePointer">{{params.value}}</span>

<div class="cell-dropdown" *ngIf="dropdown">
  <div class="input-field">
    <div class="input-field-text" [ngClass]="{'none-selected': params.value==='none'}">{{params.value}}&nbsp;</div>
    <i class="pi pi-chevron-down"></i>
  </div>
</div>

<div *ngIf="statusFormatterWithSomeIcon">
    <div [ngClass]="statusIcon"></div>{{params.value}}
</div>
<div *ngIf="statusFormatter" [ngClass]="statusIcon">&nbsp;{{params.value}}</div>
<div *ngIf="checkbox" class="center checkbox-wrapper" (click)="retainValue($event)">
  <p-checkbox binary="true" [(ngModel)]="params.value" (onChange)="onChange()" [disabled]="params.isCheckboxDisabled"></p-checkbox>
</div>
<div *ngIf="errorMsg" style="color: #D30014" tooltip [tooltipTitle]="params.value"
     [tooltipPosition]="'right'" [tooltipRequiresTruncation]='true' [tooltipHorizontalOffset]='0'>{{params.value}}</div>

<div class="cell-dropdown" *ngIf="params.irbCellActionMenu" calltoaction calltoactionPosition="right"
     [calltoactionTemplate]="irbCellActionMenuTemplateRef">
  <div class="input-field">
    <div class="input-field-text">{{params.value}}&nbsp;</div>
    <i class="pi pi-chevron-right"></i>
  </div>
  <ng-template #irbCellActionMenuTemplateRef>
    <div>
        <em class="bold" style="color: #333;padding-bottom: 3px;">{{params.menuHeaderTitle}}</em>
      <span *ngFor="let item of params.irbCellActionMenu">
                <div style="padding: 3px 0 2px 0;border-bottom: 1px solid #ccc;line-height: 16px;">
                    <a *ngIf="item.click" (click)="item.click()" href="javascript:void(0)">{{ item.label }}</a>
                    <span *ngIf="!item.click">{{ item.label }}</span>
                </div>
            </span>
    </div>
  </ng-template>
</div>

<ng-container *ngIf="params.template">
  <div [ngStyle]="{'display': (showWarnIcon) ? 'flex' : 'inline', 'justify-content': 'space-between'}">
    <span *ngIf="showWarnIcon" class="icon-warning" style="line-height: 30px;"></span>
  <a *ngIf="linkEnable" (click)="click()" tooltip [tooltipTitle]="params.value"
     [tooltipPosition]="'right'" [tooltipRequiresTruncation]='true' [tooltipHorizontalOffset]='0'
     [innerHTML]="params.template">
  </a>
  <div *ngIf="!linkEnable" tooltip [tooltipTitle]="params.value"
       [tooltipPosition]="'right'" [tooltipRequiresTruncation]='true' [tooltipHorizontalOffset]='0'
       [innerHTML]="params.template">
  </div>
  </div>
</ng-container>



